import React, { useContext, useEffect, useState } from "react";
import BasicAccountApplicationAPI from "../../api/commercial/basic-account-application";
import { ErrorContext } from "../../route/error/provider";
import CompanyMapper from "./company-mapper";
import Home from "./index";
import HomeMapper from "./mapper";
import { HomeModel } from "./types";
import { BasicAccountApplicationDocument } from "../../api/commercial/generated-types";
import { ProductRefType } from "../../context/product-context/types";
import { ProductContext } from "../../context/product-context/productContext";

export default function HomeAdapter({
  basicAccountApplication,
  triggerReload,
}: {
  basicAccountApplication: BasicAccountApplicationDocument;
  triggerReload: () => void;
}): React.JSX.Element {
  const { setError } = useContext(ErrorContext);
  const { selectedProduct } = useContext(ProductContext);
  const [currentProduct, setCurrentProduct] = useState(
    basicAccountApplication.productRef as ProductRefType,
  );

  useEffect(
    () => setCurrentProduct(selectedProduct?.productRef),
    [selectedProduct],
  );

  const company = basicAccountApplication.company;

  const homeModel = HomeMapper.mapDocumentToPageModel(
    company,
    basicAccountApplication.applicationRef,
  );

  return (
    <Home
      initial={homeModel}
      next={async (model: HomeModel) => {
        try {
          const currentCompany = model.isCompanyManuallyEntered
            ? model.manuallyEnteredCompany
            : model.selectedCompany;

          const basicApplicationRef = model.basicAccountApplicationRef;

          const request = {
            ...CompanyMapper.mapPageModelToRequest(
              currentCompany,
              basicApplicationRef,
            ),
            selectedProduct: currentProduct,
          };

          await BasicAccountApplicationAPI.updateCompanyInformation(request);
        } catch (e) {
          setError(e);
        }
        triggerReload();
      }}
    />
  );
}
